if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.productElement.classList.forEach((classApplied) => {
              if (classApplied.startsWith('color-') || classApplied === 'gradient')
                this.modalContent.classList.add(classApplied);
            });
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            // this.removeGalleryListSemantic();
            // this.updateImageSizes();
            // this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

    isPriceSmaller(priceA, priceB) {
        // Helper to convert a price string to a number
        const toNumber = (priceStr) => {
          return parseFloat(
            priceStr
              .replace('€', '')   // Remove Euro symbol
              .replace(/\s/g, '')  // Remove any spaces
              .replace(',', '.')   // Replace comma with decimal point
          );
        };

        const numA = toNumber(priceA);
        const numB = toNumber(priceB);

        // Check if the first price is smaller
        return numA < numB;
      }

      setInnerHTML(element, htmlString) {
        // element.innerHTML = htmlString;
        var html = document.createElement('div');
        html.innerHTML = htmlString.trim();

        const modal = document.createElement('div');
        modal.innerHTML = `
        <div class="quick_atc__header flex items-center gap-12">
          <div class="quick_atc__header__image"><a></a></div>
          <div class="quick_atc__header__info v-stack gap-4">
            <div class="quick_atc__header__title card__heading h5 body-m"><a>${html.querySelector('.product__title h1').innerText}</a></div>
            <div class="quick_atc__header__price price"></div>
          </div>
        </div>
        <div class="quick_atc__content">
          <div class="quick_atc__variant"></div>
          <div class="quick_atc__buy_button"></div>
        </div>
        `


        const showStrikePrice = this.isPriceSmaller(html.querySelector('.price')?.getAttribute('data-money-price'), html.querySelector('.price')?.getAttribute('data-money-compare-at-price'));

        if(html.querySelector('.price').hasAttribute('data-money-compare-at-price') && showStrikePrice){
          modal.querySelector('.quick_atc__header__price').innerHTML = `<div class="price--on-sale h-stack gap-8"><p class="price-item">${html.querySelector('.price').getAttribute('data-money-price')}</p><s class="price-item price-item--regular">${html.querySelector('.price').getAttribute('data-money-compare-at-price')}</s></div>`;
        }else{
          modal.querySelector('.quick_atc__header__price').innerHTML = `<p class="price-item">${html.querySelector('.price').getAttribute('data-money-price')}</p>`;
          modal.querySelector('.quick_atc__header__price').classList.add('price__regular');
        }
        modal.querySelectorAll('a').forEach((link) => {
          link.setAttribute('href', html.querySelector('product-info').getAttribute('data-url'));
        });
        modal.querySelector('.quick_atc__header__image a').appendChild(html.querySelector('img'));
        modal.querySelector('.quick_atc__variant').appendChild(html.querySelector('variant-radios'));
        modal.querySelector('.quick_atc__buy_button').appendChild(html.querySelector('product-form'));

        element.prepend(modal);

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());

        const tax = this.productElement.querySelector('.product__tax');
        if (tax) tax.remove();

        const size = this.productElement.querySelector('#custom-modal-trigger');
        if (size) size.remove();
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
